import LogoImage from 'assets/logo.webp'

export const LogoBlue = () => <img src={LogoImage} className="w-48" />
